<template>
  <vs-popup class="customer-contracted-product-pop-up"
            title="UPDATE CUSTOMER CONTRACT PRICING"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="contract_price_update_popup" @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">

<!--          <div class="vx-row mb-3" v-if="isCreateFromMainMenu">-->
<!--            <div class="vx-col md:w-full w-full md:mb-0">-->
<!--              <ValidationProvider vid="customer_id" name="customer_id" rules="required" v-slot="{ errors }">-->
<!--                <small class="label">Customer</small>-->
<!--                <v-select :clearable="false" name="customer_id" placeholder=""-->
<!--                          label="company_name" v-model="createForm.customer_id" :reduce="option => option.id"-->
<!--                          :options="customers" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>-->
<!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="start_timestamp" name="start_timestamp" rules="required" v-slot="{ errors }">
                <small class="label">Start date</small>

                <flat-pickr :config="startDateConfig" class="w-full" v-model="createForm.start_timestamp" placeholder="Choose Date"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="expiry_timestamp" name="expiry_timestamp" rules="required" v-slot="{ errors }">
                <small class="label">Expire date/time</small>

                <flat-pickr :config="expiryDateConfig" class="w-full" v-model="createForm.expiry_timestamp" placeholder="Choose Date"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.note" height="150px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
<!--          <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"-->
<!--                    v-model="filters['search']"-->
<!--                    class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />-->

          <vs-table stripe :data="selectedItems">

            <template slot="thead">
              <vs-th width="30%" >ITS PRODUCT CODE</vs-th>
              <vs-th width="20%">INCOTERM</vs-th>
              <vs-th width="20%">CONTRACT QUANTITY</vs-th>
<!--              <vs-th width="20%">LIST PRICE (kg/{{account_currency}})</vs-th>-->
              <vs-th width="30%">PRICE TIERS</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].formulation_code">
                  {{ data[indextr].formulation_code}}
                </vs-td>


                <vs-td :data="data[indextr].incoterm">
                  <v-select :append-to-body="true"
                            calculatePosition="top" :clearable="true" name="incoterm" placeholder=""
                            v-model="data[indextr].incoterm"
                            label="code"
                            :reduce="option => option.code"
                            :options="incoterms" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                </vs-td>

                <vs-td :data="data[indextr].contract_quantity">
                  <ValidationProvider :vid="indextr+'contract_quantity'" :name="indextr+'contract_quantity'" :rules="quantityRule(data[indextr])" v-slot="{ errors }">
                    <vs-input   type="text" v-model="data[indextr].contract_quantity" class="w-full"
                                :name="indextr+'contract_quantity'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                val-icon-pack="feather"/>
                  </ValidationProvider>
                </vs-td>

<!--                <vs-td :data="data[indextr].contract_quantity_ordered">-->
<!--                  <ValidationProvider :vid="indextr+'contract_quantity_ordered'" :name="indextr+'contract_quantity_ordered'" :rules="quantityOrderedRule(data[indextr])" v-slot="{ errors }">-->
<!--                    <vs-input   type="text" v-model="data[indextr].contract_quantity_ordered" class="w-full"-->
<!--                                :name="indextr+'contract_quantity_ordered'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"-->
<!--                                val-icon-pack="feather" />-->
<!--                  </ValidationProvider>-->
<!--                </vs-td>-->
<!--                <vs-td :data="data[indextr].list_price">-->
<!--                  <ValidationProvider :vid="indextr+'list_price'" :name="indextr+'list_price'"  v-slot="{ errors }">-->
<!--                    <vs-input readonly   type="text" v-model="data[indextr].list_price" class="w-full"-->
<!--                              :name="indextr+'list_price'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"-->
<!--                              val-icon-pack="feather" />-->
<!--                  </ValidationProvider>-->
<!--                </vs-td>-->

                <vs-td :data="data[indextr].price">
<!--                  <ValidationProvider :vid="indextr+'price'" :name="indextr+'price'" :rules="priceRule(data[indextr])" v-slot="{ errors }">-->
<!--                    <vs-input   type="text" v-model="data[indextr].price" class="w-full"-->
<!--                                :name="indextr+'price'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"-->
<!--                                val-icon-pack="feather" />-->
<!--                  </ValidationProvider>-->
                  <vs-button @click.stop="onClickOpenPriceTires(data[indextr])" class="ml-auto mt-2">Price tiers</vs-button>

                </vs-td>

              </vs-tr>
            </template>
          </vs-table>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button  button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>

    <!--    PRICE TIER POPUP-->
    <vs-popup class="customer-contracted-product-price-tiers-pop-up" title="ADD PRICE TIERS" :active.sync="priceTierPopupActive">

      <vs-table :hoverFlat="true" :data="selectedProductForPriceTier.tiers">

        <template slot="thead">
          <vs-th></vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(prices_tier, index) in data">

            <vs-td>
              <ValidationProvider :vid="index+'from'" :name="index+'from'" :rules="validate_prices_tier(index)"
                                  v-slot="{ errors }">
                <label for="">Quantity from (KG)</label>
                <vs-input  v-model="prices_tier.from" type="number" step="0.01" name="from" class="w-full"
                           :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                           val-icon-pack="feather"/>
              </ValidationProvider>
              <br>
              <ValidationProvider :vid="index+'to'" :name="index+'to'" :rules="validate_max_price_tier(index)"
                                  v-slot="{ errors }">
                <label for="">Quantity to (KG)</label>
                <vs-input v-model="prices_tier.to" type="number" step="0.01" name="to" class="w-full" :danger="!!errors[0]"
                          :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </vs-td>

            <vs-td>
              <ValidationProvider :vid="index+'fromPrice'" :name="index+'fromPrice'" :rules="''"
                                  v-slot="{ errors }">
                   <label for="">Guide price from ({{ account_currency }}/KG)</label>                
                  <vs-input disabled :value="calculateProductListPrice(selectedProductForPriceTier.pe_g, prices_tier.from, selectedProductForPriceTier.fx_rate, is_include_shipping_cost)" type="number" name="fromPrice" class="w-full"
                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather"/>
              </ValidationProvider>
              <br>
              <ValidationProvider :vid="index+'toPrice'" :name="index+'toPrice'" :rules="''"
                                  v-slot="{ errors }">
                  <label for="">Guide price from ({{ account_currency }}/KG)</label>
                  <vs-input disabled :value="calculateProductListPrice(selectedProductForPriceTier.pe_g, prices_tier.to, selectedProductForPriceTier.fx_rate, is_include_shipping_cost)" name="toPrice" class="w-full"
                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather"/>
              </ValidationProvider>
            </vs-td>

            <vs-td>
              <ValidationProvider :vid="index+'price'" :name="index+'price'" rules="required" v-slot="{ errors }">
                <label for="">Bespoke price ({{account_currency}}/KG)</label>
                <vs-input v-model="prices_tier.price" type="text" name="price" class="w-full" :danger="!!errors[0]"
                          :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </vs-td>

            <vs-td>
              <ValidationProvider :vid="index+'fromGrossMargin'" :name="index+'fromGrossMargin'" :rules="''"
                                  v-slot="{ errors }">
                   <label for="">Gross margin %</label>                
                  <vs-input disabled :value="calculateGrossMargin(selectedProductForPriceTier.pe_g, prices_tier.from, prices_tier.price, is_include_shipping_cost, selectedProductForPriceTier.fx_rate)" type="number" name="fromGrossMargin" class="w-full"
                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather"/>
              </ValidationProvider>
              <br>
              <ValidationProvider :vid="index+'toGrossMargin'" :name="index+'toGrossMargin'" :rules="''"
                                  v-slot="{ errors }">
                  <label for="">Gross margin %</label>
                  <vs-input disabled :value="calculateGrossMargin(selectedProductForPriceTier.pe_g, prices_tier.to, prices_tier.price, is_include_shipping_cost, selectedProductForPriceTier.fx_rate)" name="toGrossMargin" class="w-full"
                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather"/>
              </ValidationProvider>
            </vs-td>

            <vs-td>
              <vs-button :disabled="selectedProductForPriceTier.tiers.length === 1" class="" @click="deletePriceTier(index)" size="small"
                         color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
            </vs-td>
          </vs-tr>
        </template>

      </vs-table>
      <vs-button @click="addPriceTier" size="small" color="success" type="filled" icon-pack="feather" class="mt-4"
                 icon="icon-plus">Add prices tier
      </vs-button>

      <div class="flex flex-wrap items-center justify-end mt-8">
        <vs-button @click.stop="onClickSavePriceTierSave()" class="ml-auto mt-2">Save Price Tiers</vs-button>
        <vs-button @click="priceTierPopupActive = false" class="ml-4 mt-2" type="border" color="warning">Close</vs-button>
      </div>
    </vs-popup>
    <!--    PRICE TIER END POPUP-->

  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import Calculations from '@/mixins/Calculations';

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import confirmDatePlugin from 'flatpickr/dist/plugins/confirmDate/confirmDate.js'
  import 'flatpickr/dist/plugins/confirmDate/confirmDate.css'

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const IncotermRepository = RepositoryFactory.get('incoterm');

  function initialState() {
    return {
      open: false,
      priceTierPopupActive: false,
      selectedProductForPriceTier: {},
      id: '',
      contract_id: '',
      createForm: {},
      selectedItems: [],
      countryCodes: [],
      customerUsers: [],
      isCreateFromMainMenu: false,
      customers: [],
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
      contractedProducts: [],
      incoterms: [],
    }
  }

export default {
  name: 'UpdateCustomerProductContractsPopUp',
  data () {
    return initialState()
  },
  props: {
    account_currency  : {type: String,  default: ''}
  },
  methods:{
    async openPopup (id, contract_id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        this.contract_id = contract_id
        this.open = true;
        await this.fetchIncoterms()
        // await this.getCustomerContractedProductList()
        await this.getCustomerProjectContract()
      } catch (error) {

      }
    },
    async onClickOpenPriceTires(data) {
      this.selectedProductForPriceTier = data
      this.priceTierPopupActive = true
    },
    async fetchIncoterms() {
      try {
        const { data } = (await IncotermRepository.getListOfIncoterms(1, '', 50, '')).data
        this.incoterms = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickCreateSite () {
      const vue = this;
      this.$vs.loading()
       try {
         this.createForm.customer_id = this.id
         this.createForm.items = this.selectedItems.map((n) => {
           return {
             id: n.id,
             contract_quantity: n.contract_quantity,
             contract_quantity_ordered: n.contract_quantity_ordered,
             incoterm: n.incoterm,
             tiers: n.tiers.map((x) => {
               x.price = Number(x.price).toFixed(2)
               return x
             }),
             shipping_cost: n.shipping_cost
           }
         })
         await CustomerRepository.updateCustomerProjectContract(this.contract_id, this.createForm)
         this.showSuccessMessage('Product contract update successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },

    async getCustomerContractedProductList(fg_ids) {
      await this.$vs.loading({
        container: `#contract_price_update_popup`,
        scale: 0.45
      })
      try {
        const {data} = await CustomerRepository.getCustomerContractedProductListSelectedIds(this.id, fg_ids)
        this.contractedProducts =  data.data
      } catch (e) {
        this.$vs.loading.close(`#contract_price_update_popup > .con-vs-loading`)
      }
      this.$vs.loading.close(`#contract_price_update_popup > .con-vs-loading`)
    },

    async getCustomerProjectContract() {
      await this.$vs.loading({
        container: `#contract_price_update_popup`,
        scale: 0.45
      })
      try {
        const {data} = await CustomerRepository.getCustomerProjectContract(this.contract_id)
        this.createForm =  data.data
        const fg_ids = data.data.items.map((x) => x.id).toString()
        await this.getCustomerContractedProductList(fg_ids)
        this.selectedItems =  data.data.items.map((n) => {
          const find = this.contractedProducts.find((m) => m.id === n.id)
          n.list_price = find.list_price
          n.pe_g = find.pe_g
          n.fx_rate = find.fx_rate
          if(n.tiers.length === 0){
            n.tiers = [ {from: null, to: null, price: null} ]
          }
          return n
        })
      } catch (e) {
        this.$vs.loading.close(`#contract_price_update_popup > .con-vs-loading`)
      }
      this.$vs.loading.close(`#contract_price_update_popup > .con-vs-loading`)
    },
    // filterQueryUpdate (){
    //   this.getCustomerContractedProductList()
    // },
    // handleChangePage(page) {
    //   this.page=page;
    //   this.getCustomerContractedProductList()
    // },
    // handleSort(key, active) {
    //   if(key){
    //     active = (active==='desc')? "-":'';
    //     this.sort=active+key;
    //     this.getCustomerContractedProductList()
    //   }
    // },
    handleSelected(data) {
      // this.$vs.notify({
      //   title: `Selected ${tr.username}`,
      //   text: `Email: ${tr.email}`
      // })
    },
    priceRule(data) {
      if (!data.price && this.selectedItems.includes(data)) {
        return 'required'
      } else {
        return ''
      }
    },
    quantityRule(data) {
      if (!data.contract_quantity && this.selectedItems.includes(data)) {
        return 'required'
      } else {
        return ''
      }
    },
    quantityOrderedRule(data) {
      if (!data.contract_quantity_ordered && this.selectedItems.includes(data)) {
        return 'required'
      } else {
        return ''
      }
    },
    validate_prices_tier(index) {
      let previousIndex = index - 1
      return `min_than_or_equal:@${index}to|cross_over_max_equal:@${previousIndex}to|required`
    },
    validate_max_price_tier(index) {
      // return `max_than:@${index}from|required`
      return `max_than_or_equal:@${index}from|required`
    },
    addPriceTier() {
      this.selectedProductForPriceTier.tiers.push(
        {from: null, to: null, price: null}
      )
    },
    deletePriceTier(index) {
      this.selectedProductForPriceTier.tiers.splice(index, 1)
    },
    onClickSavePriceTierSave() {
      let data = this.selectedProductForPriceTier
      data.shipping_cost = this.is_include_shipping_cost ? Number(this.selectedProductForPriceTier.pe_g.rseq5).toFixed(2) : '0.00'
      if (Number(data.contract_quantity) > 0) {
        const find = this.selectedItems.find((m) => m.id === data.id)
        if(!find) {
          this.selectedItems.push(data)
        }
      }
      if (Number(data.contract_quantity) === 0 && data.tiers.length === 0) {
        this.selectedItems = this.selectedItems.filter((m) => data.id !== m.id)
      }
      this.priceTierPopupActive = false
    },
  },
  async mounted () {

  },
  computed: {
    startDateConfig() {
      return {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:S',
        altInput: true,
        altFormat: 'Y-m-d H:i:S',
        time_24hr: true,
        plugins: [new confirmDatePlugin({ confirmIcon: '', confirmText: 'OK', showAlways: false })]
      }
    },
    expiryDateConfig() {
      return {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:S',
        altInput: true,
        altFormat: 'Y-m-d H:i:S',
        time_24hr: true,
        plugins: [new confirmDatePlugin({ confirmIcon: '', confirmText: 'OK', showAlways: false })]
      }
    },
    is_include_shipping_cost() {
      const find = this.incoterms.find((x) => this.selectedProductForPriceTier.incoterm === x.code)
      return find ? find.is_price_included : false
    }
  },
  watch: {
    // page(){
    //   this.getCustomerContractedProductList()
    // }
  },
  components: {
    'v-select': vSelect,
    flatPickr,
  },
  mixins: [SuccessMessage, ErrorMessages, Calculations],
}
</script>

<style scoped>
  .customer-contracted-product-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 85% !important;
  }
  .customer-contracted-product-price-tiers-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }
  .customer-contracted-product-price-tiers-pop-up .vs-table--tbody-table .tr-values {
    border-bottom: 1px solid #ffffff !important;
    border-top: 1px solid #ffffff !important;
  }

</style>
